import { UserUpdatableInterface } from '../interfaces/user-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { UserDto } from './user.dto';

export class UserUpdateDto
  extends PartialType(
    PickType(UserDto, [
      'idNumber',
      'firstName',
      'lastName',
      'email',
      'primaryPhone',
      'active',
      'contractorId',
    ]),
  )
  implements UserUpdatableInterface {}
